// Vuetify 1 defaults use positional placeholders; preserve the dependency contract.
export function adminVuetifyText(key, params, $adminT) {
  let text
  switch (key) {
  case '$vuetify.dataIterator.rowsPerPageText': text = $adminT('shellAll.vuetify_dataIterator_rowsPerPageText', 'Items per page:'); break
  case '$vuetify.dataIterator.rowsPerPageAll': text = $adminT('shellAll.vuetify_dataIterator_rowsPerPageAll', 'All'); break
  case '$vuetify.dataIterator.pageText': text = $adminT('shellAll.vuetify_dataIterator_pageText', '{0}-{1} of {2}'); break
  case '$vuetify.dataIterator.noResultsText': text = $adminT('shellAll.vuetify_dataIterator_noResultsText', 'No matching records found'); break
  case '$vuetify.dataIterator.nextPage': text = $adminT('shellAll.vuetify_dataIterator_nextPage', 'Next page'); break
  case '$vuetify.dataIterator.prevPage': text = $adminT('shellAll.vuetify_dataIterator_prevPage', 'Previous page'); break
  case '$vuetify.dataTable.rowsPerPageText': text = $adminT('shellAll.vuetify_dataTable_rowsPerPageText', 'Rows per page:'); break
  case '$vuetify.noDataText': text = $adminT('shellAll.vuetify_noDataText', 'No data available'); break
  default: return key
  }

  return text.replace(/\{(\d+)\}/g, (match, index) => String(params[Number(index)]))
}
